import React from 'react';
import ConfirmModal from '../../../SprintDetail/FlowchartView/components/ConfirmModal';

const inheritedEditMessage = (pending, hasCampaignScope, campaign) => {
  if (!pending) return '';
  const name = pending.name;
  const source = pending.sourceName || 'a parent campaign';
  // Doc table: campaign-chain rows are outside this document.
  // Campaign panel: contrast against the campaign you're editing.
  const contrast = !hasCampaignScope
    ? ', outside this document'
    : campaign?.name && campaign.name !== source
      ? `, not “${campaign.name}”`
      : '';
  return `{{${name}}} is defined on “${source}”${contrast}. Changing it updates that campaign — and every nested campaign and doc that inherits this variable.`;
};

const VariablesTableConfirms = ({
  pendingRename,
  confirmPendingRename,
  cancelPendingRename,
  inheritedEdit,
  hasCampaignScope,
  campaign,
  pendingTypeChange,
  applyTypeChange,
  setPendingTypeChange,
}) => (
  <>
    <ConfirmModal
      isOpen={!!pendingRename}
      title="Rename campaign variable?"
      message={
        pendingRename
          ? `Rename “${pendingRename.oldName}” to “${pendingRename.newName}”? Nested references in this campaign’s variables will update, but other docs that use {{${pendingRename.oldName}}} may break.`
          : ''
      }
      confirmLabel="Rename"
      cancelLabel="Cancel"
      confirmVariant="warning"
      onConfirm={confirmPendingRename}
      onCancel={cancelPendingRename}
    />

    <ConfirmModal
      isOpen={!!inheritedEdit.pending}
      title="Edit inherited variable?"
      message={inheritedEditMessage(inheritedEdit.pending, hasCampaignScope, campaign)}
      confirmLabel="Edit value"
      cancelLabel="Cancel"
      confirmVariant="warning"
      onConfirm={inheritedEdit.confirmEdit}
      onCancel={inheritedEdit.cancelEdit}
    />

    <ConfirmModal
      isOpen={!!pendingTypeChange}
      title="Clear this value?"
      message={pendingTypeChange?.message || ''}
      confirmLabel="Change type"
      cancelLabel="Cancel"
      confirmVariant="warning"
      onConfirm={() => {
        if (!pendingTypeChange) return;
        applyTypeChange(
          pendingTypeChange.scope,
          pendingTypeChange.variable,
          pendingTypeChange.next
        );
        setPendingTypeChange(null);
      }}
      onCancel={() => setPendingTypeChange(null)}
    />
  </>
);

export default VariablesTableConfirms;
